import { CARE_NECESSITIES, REQUEST_FORM_FIELDS } from "core/consts";
import { z } from "zod";

export const TransitionalCareRequestSchema = z.object({
  edited: z.boolean(),
  id: z.number(),
  manual: z.boolean(),
  [REQUEST_FORM_FIELDS.CAREPROVIDER_ADDRESS_ADDRESS]: z.string(),
  [REQUEST_FORM_FIELDS.CAREPROVIDER_ADDRESS_CITY]: z.string(),
  [REQUEST_FORM_FIELDS.CAREPROVIDER_ADDRESS_ZIPCODE]: z.string(),
  [REQUEST_FORM_FIELDS.CAREPROVIDER_NAME]: z.string(),
  [REQUEST_FORM_FIELDS.REQUEST_SENT_DATE]: z.number().nullable(),
  [REQUEST_FORM_FIELDS.REQUEST_SENT_TIME]: z.number().nullable(),
  [REQUEST_FORM_FIELDS.REQUEST_STATUS]: z.number().nullable(),
  request_id: z.number().nullable(),
});

export const TransitionalCareFormSchema = z.object({
  aftercare_application_date: z.number().optional(),
  aftercare_application_explanation: z.string().optional(),
  aftercare_application_submitted: z.boolean().optional(),
  aftercare_care_level_aftercare_required: z.boolean().optional(),
  aftercare_care_level_applied: z.boolean().optional(),
  aftercare_care_level_applied_date: z.number().optional(),
  aftercare_care_level_available: z.boolean().optional(),
  aftercare_care_level_explanation: z.string().optional(),
  aftercare_medical_rehab: z.boolean().optional(),
  aftercare_mobile: z.boolean().optional(),
  aftercare_shortterm_care: z.boolean().optional(),
  aftercare_start_date: z.number().optional(),
  care_necessity: z.nativeEnum(CARE_NECESSITIES).optional(),
  clinic_ik_number: z.string().optional(),
  clinic_location_city: z.string().optional(),
  clinic_location_street: z.string().optional(),
  clinic_location_street_number: z.string().optional(),
  clinic_location_zipcode: z.string().optional(),
  clinic_name: z.string().optional(),
  handover_to_insurance_date: z.number().optional(),
  insurance_form_sent_date: z.number().optional(),
  internet_portal_used: z.boolean().optional(),
  legal_representative_consent_provided: z.boolean().optional(),
  legal_representative_first_name: z.string().optional(),
  legal_representative_last_name: z.string().optional(),
  legal_representative_location_city: z.string().optional(),
  legal_representative_location_street: z.string().optional(),
  legal_representative_location_street_number: z.string().optional(),
  legal_representative_location_zipcode: z.string().optional(),
  patient_date_of_birth: z.number().optional(),
  patient_first_name: z.string().optional(),
  patient_insurance_number: z.string().optional(),
  patient_last_name: z.string().optional(),
  patient_location_city: z.string().optional(),
  patient_location_house_number: z.string().optional(),
  patient_location_street: z.string().optional(),
  patient_location_zipcode: z.string().optional(),
  prior_treatment_end_date: z.number().optional(),
  prior_treatment_hospital_id: z.string().optional(),
  prior_treatment_start_date: z.number().optional(),
  request_list: z.array(TransitionalCareRequestSchema).optional(),
  social_worker_email: z.string().optional(),
  social_worker_fax: z.string().optional(),
  social_worker_first_name: z.string().optional(),
  social_worker_last_name: z.string().optional(),
  social_worker_telephone: z.string().optional(),
  transitional_care_department_code: z.string().optional(),
  transitional_care_description: z.string().optional(),
  transitional_care_end_date: z.number().optional(),
  transitional_care_location_id: z.string().optional(),
  transitional_care_patient_confirmation: z.boolean().optional(),
  transitional_care_patient_confirmation_date: z.number().optional(),
  transitional_care_patient_confirmation_explanation: z.string().optional(),
  transitional_care_start_date: z.number().optional(),
  transitional_care_start_search_date: z.number().optional(),
  transitional_care_suitable_providers_count: z.number().optional(),
  transitional_care_suitable_providers_more_than_twenty: z.boolean().optional(),
});
